export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <p className="text-xs md:text-sm font-medium text-primary-500 uppercase tracking-widest mb-4 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-primary-500 inline-block"></span>
              Real User Experience
            </p>
            <blockquote className="text-2xl md:text-4xl font-heading italic text-foreground-900 leading-snug">
              "The <span className="text-primary-500 not-italic font-bold">itaobuyspreadsheet</span> system completely changed how I source products. No more guessing agent fees or waiting days for replies — everything is structured, transparent, and surprisingly easy to manage."
            </blockquote>
            <div className="mt-6 flex items-center gap-3">
              <span className="text-base font-semibold text-foreground-900">Marcus R.</span>
              <i className="ri-verified-badge-fill text-lg text-accent-500"></i>
              <span className="text-sm text-foreground-500">Verified Buyer · EU</span>
            </div>
          </div>

          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="w-72 md:w-80 h-96 md:h-[420px] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20black%20and%20white%20portrait%20photography%20of%20a%20professional%20person%20in%20their%2030s%20looking%20upwards%20with%20a%20thoughtful%20expression%20side%20profile%20angle%20shoulders%20up%20composition%20clean%20white%20studio%20background%20soft%20diffused%20lighting%20editorial%20style%20high%20contrast%20monochrome%20timeless%20aesthetic&width=800&height=1000&seq=testimonial-portrait-2026&orientation=portrait"
                alt="Portrait of a satisfied itaobuyspreadsheet user"
                title="Verified itaobuyspreadsheet user testimonial"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}